export default function ValidateLogin(values, customValidations) {

  let errors = {};

  // if (values.name !== undefined) {
  //   if (!values.name) {
  //     errors.name = "Name is required";
  //   }
  // }
  if (values.email !== undefined) {
    if (!values.email) {

      if (!values.phone) {
        errors.email = "Email is required";
      }

    } else if (!/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = "Please enter a valid email address";
    }
  }
  if (values.phone !== undefined) {
    if (!values.phone) {
      if (!values.email) {
        errors.phone = "Phone is required";
      }

    } else if (!/^[2-9]\d{2}[2-9]\d{2}\d{4}$/.test(values.phone)) {
      errors.phone = "Please enter a valid phone number";
    }
  }
  if (customValidations.cem !== undefined) {
    if (values.acceptCEM !== undefined && customValidations.cem) {
      if (!values.acceptCEM) {
        errors.acceptCEM = "Please accept the Commercial Electronic Message Consent";
      }
    }
  }
  if (customValidations.notification !== undefined) {
    if (values.byEmail !== undefined && values.byText !== undefined && customValidations.notification) {
      if (!values.byEmail && !values.byText) {
        errors.byEmail = true;
        errors.byText = "Please select atleast one method to get in touch with you (Email/Text).";
      }
    }
  }

  if (values.byEmail !== undefined) {
    if (values.byEmail) {
      if (!values.email) {
        errors.byEmail = "Please enter an email address for notifications";
        errors.email = "Email is required"
      }
    }
  }
  if (values.byText !== undefined) {
    if (values.byText) {

      if (!values.phone) {
        errors.byText = "Please enter a phone number for notifications";
        errors.phone = "Phone is required"
      }
    }
  }
  if (values.contactMe !== undefined) {
    if (values.contactMe) {

      if (!values.contactMe) {
        errors.contactMe = "Please accept";
      }
    }
  }
  if (values.consentEmail !== undefined) {
    if (values.consentEmail) {
      if (!values.email) {
        errors.consentEmail = "Please enter an email address for notifications";
        errors.email = "Email is required"
      }
    }
  }

  if (values.firstName !== undefined) {
    if (!values.firstName) {
      errors.firstName = "First Name is required";
    }
  }
  if (values.lastName !== undefined) {
    if (!values.lastName) {
      errors.lastName = "Last Name is required";
    }
  }

  if (values.address1 !== undefined) {
    if (!values.address1) {
      errors.address1 = "Address Line 1 is required";
    }
  }
  // if (values.address2 !== undefined) {
  //   if (!values.address2) {
  //     errors.address2 = "Address Line 2 is required";
  //   }
  // }
  if (values.city !== undefined) {
    if (!values.city) {
      errors.city = "City is required";
    }
  }

  // if (values.province !== undefined) {
  //   if (!values.province) {
  //     errors.province = "Province is required";
  //   }
  // }

  if (values.postalCode !== undefined) {
    if (!values.postalCode) {
      errors.postalCode = "Postal Code is required";
    }
  }

  if (values.acceptTAndC !== undefined) {
    if (!values.acceptTAndC) {
      errors.acceptTAndC = "Please accept the Terms and Conditions";
    }
  }



  return errors;
}